import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  marketValueLabel: {
    paddingBottom: 0.5,
  },
  marketValueText: {
    color: 'white',
    marginBottom: -5.5,
  },
  dayChange: {
    flexDirection: 'row',
    paddingBottom: 0.5,
  },
  dayChangeLabel: {
    marginRight: 12,
  },
  dayChangeText: {
    marginRight: 8,
  },
});
